// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36aj-","placeholdersHeader":"styles_placeholdersHeader__UuiUM","editorStyle":"styles_editorStyle__qrKQ7","placeholdersBox":"styles_placeholdersBox__2D_1q"};